var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.675 11.55C17.675 11.0528 17.8726 10.5759 18.2242 10.2242C18.5758 9.87259 19.0527 9.67505 19.55 9.67505C20.0473 9.67505 20.5242 9.87259 20.8758 10.2242C21.2275 10.5759 21.425 11.0528 21.425 11.55C21.425 12.0473 21.2275 12.5242 20.8758 12.8759C20.5242 13.2275 20.0473 13.425 19.55 13.425C19.0527 13.425 18.5758 13.2275 18.2242 12.8759C17.8726 12.5242 17.675 12.0473 17.675 11.55ZM17.675 11.55H6.42502M6.42502 11.55C6.42502 12.0473 6.22747 12.5242 5.87584 12.8759C5.52421 13.2275 5.0473 13.425 4.55002 13.425C4.05274 13.425 3.57582 13.2275 3.22419 12.8759C2.87256 12.5242 2.67502 12.0473 2.67502 11.55C2.67502 11.0528 2.87256 10.5759 3.22419 10.2242C3.57582 9.87259 4.05274 9.67505 4.55002 9.67505C5.0473 9.67505 5.52421 9.87259 5.87584 10.2242C6.22747 10.5759 6.42502 11.0528 6.42502 11.55ZM19.55 5.92505C20.0473 5.92505 20.5242 5.7275 20.8758 5.37587C21.2275 5.02424 21.425 4.54733 21.425 4.05005C21.425 3.55277 21.2275 3.07585 20.8758 2.72422C20.5242 2.37259 20.0473 2.17505 19.55 2.17505C19.0527 2.17505 18.5758 2.37259 18.2242 2.72422C17.8726 3.07585 17.675 3.55277 17.675 4.05005C17.675 4.54733 17.8726 5.02424 18.2242 5.37587C18.5758 5.7275 19.0527 5.92505 19.55 5.92505ZM19.55 20.925C20.0473 20.925 20.5242 20.7275 20.8758 20.3759C21.2275 20.0242 21.425 19.5473 21.425 19.05C21.425 18.5528 21.2275 18.0759 20.8758 17.7242C20.5242 17.3726 20.0473 17.175 19.55 17.175C19.0527 17.175 18.5758 17.3726 18.2242 17.7242C17.8726 18.0759 17.675 18.5528 17.675 19.05C17.675 19.5473 17.8726 20.0242 18.2242 20.3759C18.5758 20.7275 19.0527 20.925 19.55 20.925Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.675 4.0498H13.925C12.05 4.0498 11.1125 4.9873 11.1125 6.8623V16.2373C11.1125 18.1123 12.05 19.0498 13.925 19.0498H17.675",
    stroke: "#4DFFFF",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.633d6c9ba6353f909ce722573b21a8e2.svg";
export { ForwardRef as ReactComponent };